<template>
  <div>
    <NavBar />
    <Create :tipos="tipos" :create="createItem" :close="closeCreate"></Create>
    <Edit :tipos="tipos" :item="currentItem" :update="updateItem" :close="closeEdit"></Edit>
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="40.447px"
              height="40.446px"
              viewBox="0 0 40.447 40.446"
              style="enable-background:new 0 0 40.447 40.446;"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M38.556,26.536l-7.323-7.324c-1.216-1.216-2.894-1.886-4.722-1.886c-1.502,0-3.019,0.456-4.377,1.273l-0.289-0.288 c1.834-3.064,1.687-6.802-0.612-9.1l-7.322-7.324C12.694,0.67,11.015,0,9.187,0C6.952,0,4.679,0.991,2.952,2.72l-0.23,0.229 c-3.25,3.252-3.623,8.167-0.832,10.958l7.324,7.323c1.217,1.219,2.893,1.889,4.721,1.889c1.502,0,3.018-0.457,4.377-1.273 l0.289,0.289c-1.834,3.062-1.687,6.801,0.613,9.1l7.32,7.322c1.218,1.217,2.896,1.89,4.725,1.89c2.234,0,4.51-0.992,6.238-2.726 l0.227-0.227C40.974,34.243,41.347,29.327,38.556,26.536z M13.933,18.119c-0.348,0-0.838-0.073-1.186-0.422l-7.324-7.324 C4.7,9.651,4.864,7.876,6.255,6.485l0.23-0.229C7.27,5.471,8.28,5.001,9.186,5.001c0.35,0,0.838,0.073,1.188,0.422l7.322,7.324 c0.375,0.374,0.504,1.032,0.355,1.771L14.032,10.5c-0.978-0.977-2.56-0.977-3.535,0c-0.978,0.976-0.978,2.559,0,3.535l4.015,4.013 C14.319,18.088,14.123,18.119,13.933,18.119z M34.183,33.963l-0.226,0.227c-0.784,0.785-1.795,1.256-2.7,1.256 c-0.349,0-0.839-0.074-1.188-0.424l-7.322-7.322c-0.375-0.373-0.504-1.031-0.354-1.771l4.019,4.02 c0.488,0.486,1.127,0.73,1.77,0.73c0.639,0,1.277-0.244,1.768-0.73c0.978-0.979,0.978-2.561,0-3.535l-4.014-4.014 c0.194-0.041,0.391-0.07,0.58-0.07c0.348,0,0.838,0.072,1.186,0.42l7.323,7.324C35.744,30.795,35.578,32.57,34.183,33.963z"
                />
              </g>
            </svg>
            Links
          </h1>
          <ul class="tabs">
            <li>
              <router-link to="/links/cabecalho">Cabeçalho</router-link>
            </li>
            <li>
              <router-link to="/links/rodape">Rodapé</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th>Link</th>
                    <th>Ordem</th>
                    <th>Nova aba</th>
                    <th>
                      <button
                        class="button button-success button-sm button-block"
                        v-on:click="openCreate()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff;"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          />
                        </svg>
                        Novo
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in item.topo">
                    <td>{{ i.descricao }}</td>
                    <td>{{ i.link }}</td>
                    <td>
                      <span class="label primary">{{ i.ordem }}</span>
                    </td>
                    <td>
                      <span class="label success" v-if="i.aba">Sim</span>
                      <span class="label error" v-else>Não</span>
                    </td>
                    <td class="actions">
                      <a class="button button-primary" v-on:click="openEdit(index)">
                        <svg
                          x="0px"
                          y="0px"
                          style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;"
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            />
                          </g>
                        </svg>
                      </a>
                      &nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteItem(index)"
                      >
                        <svg
                          style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;"
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            />
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SimpleVueValidation from "simple-vue-validator";
import { get, put } from "../../helpers/apiRequest";
import Create from "./Menu/Create";
import Edit from "./Menu/Edit";

const Validator = SimpleVueValidation.Validator;

const url = "/links";

export default {
  name: "links",
  components: {
    Create,
    Edit
  },
  data() {
    return {
      loading: false,
      tipos: {},
      item: {
        _id: "",
        topo: []
      },
      currentItem: {
        img: "",
        descricao: "",
        link: "",
        ordem: "",
        aba: "",
        tipo: ""
      }
    };
  },
  methods: {
    onSubmit() {
      this.$validate().then(success => success && this.save());
    },
    save(saveSilent = false) {
      if (!saveSilent) {
        this.loading = true;
      }
      put(`${url}/${this.item._id}`, this.item)
        .then(json => {
          this.loading = false;
          if (!saveSilent) {
            this.$swal({
              title: "Dados Alterados com Sucesso!",
              type: "success"
            });
          }
        })
        .catch(err => console.log("err", err));
    },
    deleteItem(index) {
      const { _id } = this.item;
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727"
      }).then(
        () => {
          this.item.topo = this.item.topo.filter((_, k) => +index !== +k);
          this.save(true);
        },
        () => {}
      );
    },
    openCreate() {
      this.$modal.show("linksMenuCreate");
    },
    closeCreate() {
      this.$modal.hide("linksMenuCreate");
    },
    createItem(descricao, link, ordem, aba, tipo) {
      console.log(aba);
      this.item.topo = this.item.topo || [];
      this.item.topo.push({
        descricao,
        link,
        ordem,
        aba,
        tipo,
        img: ""
      });
      this.save(true);
    },
    openEdit(index) {
      const { descricao, link, ordem, aba, tipo, img } = this.item.topo[index];
      this.loading = false;
      this.currentItem = Object.assign(
        {},
        {
          index,
          img,
          descricao,
          link,
          ordem,
          aba,
          tipo
        }
      );
      this.$modal.show("linksMenuEdit");
    },
    closeEdit() {
      this.currentItem = {
        img: "",
        descricao: "",
        link: "",
        ordem: "",
        aba: "",
        tipo: ""
      };
      this.loading = false;
      this.$modal.hide("linksMenuEdit");
    },
    updateItem() {
      const {
        index,
        img,
        descricao,
        link,
        ordem,
        aba,
        tipo
      } = this.currentItem;
      this.item.topo = this.item.topo.map((i, k) => {
        if (+index === +k) {
          return { img, descricao, link, ordem, aba, tipo };
        }
        return i;
      });
      this.save();
      this.closeEdit();
    }
  },
  beforeMount() {
    this.loading = true;
    get(url)
      .then(json => {
        this.loading = false;
        this.item = json.links;
        this.tipos = json.tipos;
      })
      .catch(err => console.log("err", err));
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Links/Menu.vue